import React, { FC } from "react";
import { useTranslation } from "i18n";
import { StickyCTABar, IStickyButtonConfig } from "component-library";
import { useModal } from "shared-hooks";
import { getAgentCancelButton } from "pages/SelfTapeRequestPage/SelfTapeRequestAgentParts/AgentActionFooter/helpers/getAgentCancelButton";
import { getCancelButton } from "../../helpers";
import { SendToClientModal } from "../../SelfTapeRequestAgentParts";
import AgentTagTapesActionFooter from "../AgentTagTapesActionFooter";

interface Props {
  selfTapeRequestId: string;
  clientName: string;
  submitButtonConfig: IStickyButtonConfig;
  isAccepted?: boolean;
  isTagminUser?: boolean;
  isTagTapesUser?: boolean;
  forwardedToPerformer?: boolean;
}

const AgentActionFooter: FC<React.PropsWithChildren<Props>> = ({
  selfTapeRequestId,
  clientName,
  submitButtonConfig,
  isAccepted,
  isTagminUser,
  isTagTapesUser,
  forwardedToPerformer,
}) => {
  const { t } = useTranslation();
  const { visible, show, close } = useModal();

  if (isTagTapesUser) {
    return (
      <AgentTagTapesActionFooter
        submitButtonConfig={submitButtonConfig}
        selfTapeRequestId={selfTapeRequestId}
        isAccepted={isAccepted}
      />
    );
  }

  return (
    <>
      <StickyCTABar
        cancel={getAgentCancelButton({
          selfTapeRequestId,
          isAccepted,
          forwardedToPerformer,
          isTagminUser,
          showModal: show,
          t,
        })}
        prev={getCancelButton(t)}
        next={submitButtonConfig}
        ctaBarAdditionalClassName="max-w-[1440px]"
        isSticky
      />
      {visible && (
        <SendToClientModal
          selfTapeRequestId={selfTapeRequestId}
          clientName={clientName}
          closeModal={close}
          isTagminUser={isTagminUser}
          isTagTapesUser={isTagTapesUser}
        />
      )}
    </>
  );
};

export default AgentActionFooter;
